import { connect } from 'react-redux';
import Home from './Home';

const mapDispatchToProps = {
};

const mapStateToProps = (state) => ({
  resource: state.resource,
  geo: state.geo,
  locale: state.locale,
  testimonials: state.testimonials
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
